import { ID } from './id';

// What a checkout sells; a held subscription's Interval (user-subscription.ts) also covers week and two-weeks.
export enum PriceInterval {
  Year = 'year',
  Month = 'month',
  Lifetime = 'lifetime',
}

// The stripe-getPricesForUser response, a frozen contract between the backend and web.
export type Price = {
  id: ID;
  currency: string;
  interval: PriceInterval;
  amountInCents: number;
  saving: number;
  savingPercentage: number;
  expires?: string | null;
  coupon?: {
    id: ID;
    name: string | null;
    saving: number;
    amount?: number | null;
    percentage?: number | null;
    // the campaign's own end date (STRIPE_COUPON_EXPIRES_PER_TYPE), not the price's `expires`
    expiresAt?: string | null;
  } | null;
};

export type Discount = {
  id: ID;
  applicableIntervals: PriceInterval[];
  percentage?: number | null;
  amount?: number | null;
};
